import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from './ConfirmDialog';

const ConfirmActivityModal = (props) => {

  // Call props.timeout after short interval of time based on timeoutDurationInSeconds, if the user do not close the modal
  useEffect(() => {
    const timeout = setTimeout(props.onTimeout, props.timeoutDurationInSeconds * 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <ConfirmDialog
      appElementId="react-kiosk-container"
      isOpen={true}
      onConfirm={props.onConfirm}
      headerText={props.headerText}
      descriptionText={props.descriptionText}
      confirmText={props.confirmText}
    />
  );
}

ConfirmActivityModal.defaultProps = {
  confirmText: "Yes, I'm still here",
  headerText: "Are you still there?"
};

ConfirmActivityModal.propTypes = {
  onTimeout: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmText: PropTypes.string,
  descriptionText: PropTypes.string.isRequired,
  headerText: PropTypes.string,
  timeoutDurationInSeconds: PropTypes.number.isRequired
};

export default ConfirmActivityModal;
